import React from 'react';
import { Switch, Route, useHistory } from 'react-router-dom';
import { AdminRoute, NotFoundRoute, EmployeeRoute } from './Routes';
import { useNavigator } from './useNavigator.config';
import { useAuth } from '../context';
import { useFetch } from '../hooks';

export const Navigator: React.FC = React.memo(() => {
    const { push, location } = useHistory();
    const navigator = useNavigator();
    const { session, checkValidSession, logout } = useAuth();
    const [checkSessionPostHandler] = useFetch('/utCheckSession', 'POST');
    const [counter, setCounter] = React.useState<number>(0);

    React.useEffect(() => {
        const checkAdminPathnames = () =>
            location.pathname === '/members/view' ||
            location.pathname === '/policies/admin' ||
            location.pathname === '/policies' ||
            location.pathname === '/blogs/add';
        const checkSession = async () => {
            const result = await checkSessionPostHandler({
                data: {
                    member_guid: session.MemberGuid,
                    session_guid: session.SessionGuid
                }
            });
            result.success
                ? checkValidSession(result.data, 'checkSession')
                : counter <= 5
                ? setCounter(prevCount => prevCount + 1)
                : logout();
            // : logout();
        };
        (checkAdminPathnames() || location.pathname === '/login') &&
        session.SessionGuid
            ? checkSession()
            : checkAdminPathnames() && !session.SessionGuid && push('/login');
    }, [
        checkValidSession,
        location.pathname,
        logout,
        checkSessionPostHandler,
        session.MemberGuid,
        session.SessionGuid,
        counter,
        push
    ]);
    React.useEffect(() => window.scrollTo(0, 0), [location.pathname]);

    return (
        <Switch>
            {navigator.public.map(route => (
                <Route
                    key={route.path}
                    path={route.path}
                    component={route.component}
                    exact
                />
            ))}
            {navigator.admin.map(adminRoute => (
                <AdminRoute key={adminRoute.path} path={adminRoute.path}>
                    <adminRoute.component />
                </AdminRoute>
            ))}
            {navigator.employee.map(employeeRoute => (
                <EmployeeRoute
                    key={employeeRoute.path}
                    path={employeeRoute.path}
                >
                    <employeeRoute.component />
                </EmployeeRoute>
            ))}
            <NotFoundRoute />
        </Switch>
    );
});
